var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomTemplateStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 12,
    ry: 12,
    fill: "#000429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.71461L9.02425 6.00685L9.74019 4.5L10.4561 6.00685L11.9804 6.71461L10.4561 7.42237L9.74019 8.92922L9.02425 7.42237L7.5 6.71461ZM9.34757 17.2854L10.8718 16.5776L11.5878 15.0708L12.3037 16.5776L13.8279 17.2854L12.3037 17.9932L11.5878 19.5L10.8718 17.9932L9.34757 17.2854ZM12.142 11.121L13.9665 10.2763L14.821 8.4726L15.6755 10.2763L17.5 11.121L15.6755 11.9658L14.821 13.7694L13.9665 11.9658L12.142 11.121Z",
    fill: "#FFD965"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomTemplateStars);
export default __webpack_public_path__ + "static/media/customTemplateStars.4af5b8ad47eaa2be57dc4728cababb2a.svg";
export { ForwardRef as ReactComponent };